import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './index.scss';
import SearchBar from '../SearchBar/index.jsx';
import SavingsSectionv3 from '../static/SavingsSectionv3.jsx';
import { Helmet } from 'react-helmet';
import TopDrugsNew from '../../components/TopDrugsNew/index.jsx';
import {
  HOME_CANONICAL,
  HOME_DESC,
  HOME_OG_DESC,
  HOME_OG_TITLE,
  HOME_TITLE,
  HOME_TITLE_ES,
  HOME_DESC_ES,
  HOMEPAGE_MID_SIGNUP_MODAL,
  INTELLIMIZE_POPULAR_DRUG_CLICK
} from '../../constants/defaults';

import _ from 'lodash';
import BlogPosts from '../NewBlogPosts';
import HomeSignUpv2 from '../HomeSignUp-v2';
import { withTranslation } from 'react-i18next';
import FamilywizeFaq from '../common/FamilywizeFaq';
import loadable from '@loadable/component';
import { modalActions } from '../../reducers/modalSlice';
import PharmaciesBanner from '../PharmaciesBanner';
import AppsPromoHomeV2 from '../AppsPromoHomeV2';
import { AuthContext } from '../../Contexts';
import TrendingDrugs from '../common/TrendingDrugs/index.js';
import { HOME_PAGE_TEST_SCRIPT } from '../../constants/abTestHomeScript.js';
import { HOTJAR_SCRIPT } from '../../constants/hotjarScript.js';
import AddVideo from '../common/AddVideo/index.js';
import PriceSection from '../PriceSection/index.jsx';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);

const AuthenticatedModal = loadable(() =>
  import('../HomeDeliveryNew/AuthenticateModal')
);

if (typeof window !== 'undefined' && !window.__headerScrollInit) {
  window.__headerScrollInit = true;
  window.addEventListener('scroll', () => {
    const header = document.querySelector('.newSearchBar');
    if (!header) return;
    //const isScrolled = window.scrollY > 280;
    const breakpoint = 768;
    const isMobile = window.innerWidth <= breakpoint;
    const scrollThreshold = isMobile ? 180 : 280;
    const isScrolled = window.scrollY > scrollThreshold;
    header.classList.toggle('scrolled', isScrolled);
  });
}

const Home = props => {
  const { t, i18n, location, history, isMobileDevice, staticContext } = props;
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();

  // Initialize repos from window or staticContext
  const getInitialRepos = () => {
    if (
      typeof window !== 'undefined' &&
      typeof window.__INITIAL_DATA__ !== 'undefined'
    ) {
      return window.__INITIAL_DATA__;
    }
    return staticContext?.data;
  };

  const [repos] = useState(getInitialRepos());
  const [rxPageRecentDrug, setRxPageRecentDrug] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openSignupModal, setOpenSignupModal] = useState(false);

  const toggleSearch = () => {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    clickEvent.isFromNavbar = true;
    const myButton = document.getElementById('mobile-search-icon');
    myButton?.dispatchEvent(clickEvent);
  };

  const clearDrug = () => {
    localStorage.removeItem('RecentlyViewedDrugs');
    setRxPageRecentDrug(false);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const recentlyViewedDrugs = JSON.parse(
        localStorage.getItem('RecentlyViewedDrugs')
      );
      !_.isEmpty(recentlyViewedDrugs) && setRxPageRecentDrug(true);
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = openSignupModal ? 'hidden' : '';
  }, [openSignupModal]);

  const geLdJson = () => {
    let LdJson = {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      description:
        'SingleCare is a free prescription discount card. Think of us as your ticket to better savings. SingleCare is free to use, and there are no hidden fees or obligations..',
      url: 'https://www.singlecare.com/',
      logo: 'https://static-singlecare.s3.amazonaws.com/tenant/singlecare/images/main-logo.png',
      name: 'SingleCare',
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+1-844-234-3057',
          contactType: 'customer service',
          contactOption: 'TollFree',
          areaServed: ['US', 'CA']
        }
      ],
      sameAs: [
        'https://www.facebook.com/SingleCare/',
        'https://twitter.com/singlecare',
        'https://www.linkedin.com/company/singlecare/',
        'https://www.instagram.com/singlecare/',
        'https://www.youtube.com/channel/UCd9kiPIjCQw95-2BHCYePKA'
      ]
    };
    return JSON.stringify(LdJson);
  };

  const setMetaData = () => {
    let isEs = _.isEqual(i18n.language, 'es');
    return (
      <Helmet>
        <title>{isEs ? HOME_TITLE_ES : HOME_TITLE}</title>
        <meta name="description" content={isEs ? HOME_DESC_ES : HOME_DESC} />
        <meta
          name="google-site-verification"
          content="cwuLTbqDFQXCVR6HYD2QGXryXU9eWcaqNMP6PT9nb48"
        />
        <meta name="msvalidate.01" content="2379A44788D9E36D5937176579661917" />
        <meta name="yandex-verification" content="8a995f8fd1dce3eb" />
        <meta property="og:title" content={HOME_OG_TITLE} />
        <meta property="og:description" content={HOME_OG_DESC} />
        <meta
          property="og:image"
          content={`${HOME_CANONICAL}/content/images/homepage/newSingleCareLogo.jpg`}
        />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${location.pathname}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
        <link
          rel="canonical"
          href={`https://www.singlecare.com${location.pathname}`}
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/es"
          hrefLang="es-us"
        />
        <script type="application/ld+json">{geLdJson()}</script>
        {isHomepage && (
          <script type="text/javascript">{HOME_PAGE_TEST_SCRIPT}</script>
        )}
        {API.ALLOW_HOTJAR && (
          <script type="text/javascript">{HOTJAR_SCRIPT}</script>
        )}
      </Helmet>
    );
  };

  const handleDrugClick = (e, drugName) => {
    _.sendIntellimizeEvent(INTELLIMIZE_POPULAR_DRUG_CLICK);
    if (!_.isEmpty(drugName)) {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        setIsLoading(true);
        setTimeout(() => setIsLoading(false), 3000);
      } else setIsLoading(true);
    }
  };

  const handleSignupModal = () => {
    setOpenSignupModal(true);
    dispatch(modalActions.homepageMidSignupModal());
    let { signUpPath } = _.getSignUpPath(HOMEPAGE_MID_SIGNUP_MODAL);
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      ...signUpPath
    });
  };

  const hideAuthenticateModal = () => {
    setOpenSignupModal(false);
  };

  let lang = i18n.language;
  let recentlyViewedDrugs = [];
  if (typeof window !== 'undefined') {
    recentlyViewedDrugs = JSON.parse(
      localStorage.getItem('RecentlyViewedDrugs')
    );
  }
  const isHomepage = location.pathname === '/';

  return (
    <main>
      {isLoading ? (
        <div className="loaderCenter mainLoader">
          <img
            src={
              /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
                ? '/content/images/loader/loader.png'
                : '/content/images/loader/loading.gif'
            }
            alt="loader"
            className="center"
          />
        </div>
      ) : (
        <div className="homepage homepage-new homepagev2">
          {setMetaData()}

          <section id="homeHeroSection">
            <div
              className={`homeHeroSection-AB ${
                rxPageRecentDrug ? 'heroBg minHigh' : 'heroBg'
              }`}
            >
              <div className="newHeroSection">
                <h1 className="mainHeading">
                  <span className="desktop-only">
                    <span className="desktop-show">
                      {t('Real prescription savings')}
                    </span>
                    <span className="desktop-show swoosh">{t('Really')}</span>
                  </span>
                  <span className="mobileHeader mobile-only swoosh">
                    {t('Really')}
                  </span>
                  <span className="mobileHeader mobile-only">
                    {t('Real prescription savings')}
                  </span>
                </h1>
              </div>
              <div
                className={`newSearchBar ${
                  !authContext?.userData?.isLoggedIn ? '' : 'loginNewSearchBar'
                }`}
              >
                <div className="desktop-only">
                  <SearchBar
                    classes="search-container"
                    handleZipCodeChange={() => null}
                    history={history}
                    showZipCode={false}
                    inputPlaceHolder={`${
                      !isMobileDevice && t('Search placeholder desktop')
                    }`}
                    isNavbarSearch={false}
                  />
                </div>
                <div className="mobile-only mm" onClick={toggleSearch}>
                  <SearchBar
                    classes="search-container"
                    handleZipCodeChange={() => null}
                    history={history}
                    showZipCode={false}
                    inputPlaceHolder={t('Search placeholder mobile')}
                    isNavbarSearch={false}
                  />
                </div>
              </div>

              {rxPageRecentDrug && window.innerWidth < 767 && (
                <div className="newViewedrxSection">
                  <section
                    id="viewed-rx--section"
                    className="viewed-rx less_recently_viewed_items"
                  >
                    <div className="viewed-rx--content">
                      <header className="clear-recently-viewed">
                        <p className="header-text">{t('Recently viewed')}</p>
                        <p className="header-btn">
                          <button
                            type="button"
                            data-mp-text="Clear all recently viewed drug"
                            className="sc-text-btn--white clear-all-btn viewed-rx--clear-all"
                            onClick={clearDrug}
                          >
                            Clear
                          </button>
                        </p>
                      </header>

                      <div className="viewed-rx--list">
                        <ul>
                          {recentlyViewedDrugs
                            .slice(0)
                            .reverse()
                            .map((drug, id) => {
                              return (
                                <li key={id} className="rx-item">
                                  <a
                                    href={_.withLocale(
                                      lang,
                                      `/prescription/${
                                        drug.SeoName
                                      }?q=${encodeURIComponent(drug.Name)}`
                                    )}
                                    data-mp-text="Recently viewed drug"
                                    className="rx-item--drug-link"
                                  >
                                    <span className="recent-drug--name">
                                      {drug.Name}
                                    </span>
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </section>
                </div>
              )}

              <div
                className={
                  rxPageRecentDrug
                    ? 'newTopDrugsSection addBg'
                    : 'newTopDrugsSection'
                }
              >
                <TopDrugsNew handleDrugClick={handleDrugClick} />
              </div>
            </div>
          </section>

          {!_.isEqual(i18n.language, 'es') && <PriceSection />}

          <PharmaciesBanner />
          <SavingsSectionv3 />
          {!authContext?.userData?.isLoggedIn && (
            <div className="homeSignupSection">
              <HomeSignUpv2 openSignupModal={handleSignupModal} />
            </div>
          )}

          {location.pathname.match(/familywize|es\/familywize/) && (
            <FamilywizeFaq />
          )}

          <AppsPromoHomeV2
            QRImage={'/content/images/homepagev2/czbygisj_qr_code.svg'}
            appStoreLink={'https://singlecare.onelink.me/OxIQ/5f177f77'}
            playStoreLink={'https://singlecare.onelink.me/OxIQ/6ec13330'}
            altText={t('QR code to download the app')}
          />

          <TrendingDrugs data={repos?.trendingDrugs} />
          {!_.isEqual(i18n.language, 'es') && (
            <BlogPosts blogWidth={'blogPosts-xl'} />
          )}

          {!_.isEqual(i18n.language, 'es') && <AddVideo />}
          {openSignupModal && (
            <div className="mainModal afterSignupmodal">
              <div
                className="transparentBg"
                onClick={() => setOpenSignupModal(false)}
              ></div>
              <div className="signUpModal">
                <AuthenticatedModal
                  hideAuthenticateModal={hideAuthenticateModal}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default withTranslation()(Home);
